import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { ArrowRight, ArrowLeft } from 'react-feather';

import { useUnit, useUnits } from 'hooks/units/index';
import { getNextUnit, getPreviousUnit } from 'helpers/index';
import { getUnitRoute } from 'helpers/unitRoute';

import styles from 'styles/Unit.module.scss';
import { UncontrolledTooltip } from 'reactstrap';

const ChangeUnit = ({ isRight }) => {
  const unitSelected = useUnit();
  const units = useUnits();
  const router = useRouter();
  const { query } = router;
  const nextUnit = useMemo(
    () => getNextUnit(units, unitSelected?._id),
    [units, unitSelected],
  );
  const previousUnit = useMemo(
    () => getPreviousUnit(units, unitSelected?._id),
    [units, unitSelected],
  );

  const handleRouteUnit = async () => {
    if (isRight ? !nextUnit : !previousUnit) {
      return;
    }

    if (isRight) {
      const nextUnit = getNextUnit(units, unitSelected?._id);
      await router.push(getUnitRoute(query?.slug, nextUnit));
    } else {
      const previousUnit = getPreviousUnit(units, unitSelected?._id);
      await router.push(getUnitRoute(query?.slug, previousUnit));
    }
  };

  return (
    <>
      <div
        className={styles.arrowChangeUnit}
        style={{
          ...(isRight && { right: -35 }),
          ...(!isRight && { left: -35 }),
        }}
        onClick={handleRouteUnit}
      >
        {isRight ? (
          <ArrowRight id="arrowRight" />
        ) : (
          <ArrowLeft id="arrowLeft" />
        )}
      </div>
      <UncontrolledTooltip
        placement="bottom"
        target={isRight ? 'arrowRight' : 'arrowLeft'}
      >
        {isRight ? 'Next unit' : 'Previous unit'}
      </UncontrolledTooltip>
    </>
  );
};

ChangeUnit.defaultProps = {
  isRight: false,
};

ChangeUnit.propTypes = {
  isRight: PropTypes.bool.isRequired,
};

export default ChangeUnit;
